export default __webpack_public_path__ + "static/media/questionnaire.986c74bd.png";